import React from 'react'
import styles from '../../../CSS/main.css'
import Box from '../../Components/Box'
import {WebsiteFormState} from './types'
import {ModerationMode} from "../../../../types";

type BaseProps = {
  readonly formState: WebsiteFormState
  readonly handleChange: {
    (e: React.ChangeEvent<HTMLElement>): void
  }
}

type EditProps = BaseProps & {
  readonly createMode?: false
  readonly deleteSite: () => void
}

type CreateProps = BaseProps & {
  readonly createMode: true
  readonly deleteSite?: undefined
}

type Props = EditProps | CreateProps

const EditWebsiteForm: React.VFC<Props> = ({
  formState,
  handleChange,
  deleteSite,
  createMode,
}) => {
  const { disabled, moderationMode } = formState

  return (
    <Box>
      <div className={styles.ProfileBox}>
        <div className={styles.ProfileLeft}>
          {/*<label>*/}
          {/*  Site Name:*/}
          {/*  <br />*/}
          {/*  <input*/}
          {/*    name={'siteName'}*/}
          {/*    type='text'*/}
          {/*    value={siteName}*/}
          {/*    onChange={handleChange}*/}
          {/*  />*/}
          {/*  <span className={styles.Notice}>Required.</span>*/}
          {/*</label>*/}

          {/*<label>*/}
          {/*  URL:*/}
          {/*  <br />*/}
          {/*  <input*/}
          {/*    name={'url'}*/}
          {/*    type='text'*/}
          {/*    value={url}*/}
          {/*    onChange={handleChange}*/}
          {/*  />*/}
          {/*  <span className={styles.Notice}>Required.</span>*/}
          {/*</label>*/}

          <label>
            Comments:
            <br />
            <select
              onChange={handleChange}
              name='disabled'
              value={disabled}>
              <option value={'false'}>Enabled</option>
              <option value={'true'}>Disabled</option>
            </select>
            <span className={styles.Notice}>
              Comments will be hidden until enabled.
            </span>
          </label>

          <label>
            Moderation mode:
            <br />
            <select
              onChange={handleChange}
              name='moderationMode'
              value={moderationMode}>
              <option value={ModerationMode.NONE}>None</option>
              <option value={ModerationMode.LIVE_AND_PENDING}>Live and pending</option>
            </select>
          </label>

          {/*{!createMode && (*/}
          {/*  <div className={styles.ButtonBlock}>*/}
          {/*    <Button*/}
          {/*      onClick={deleteSite}*/}
          {/*      additionalClassNames={[styles.ButtonDelete]}>*/}
          {/*      Delete Site*/}
          {/*    </Button>*/}
          {/*  </div>*/}
          {/*)}*/}
        </div>
        {/*<div className={styles.ProfileRight}>*/}
        {/*  <label id='LabelSnippet'>*/}
        {/*    Code Snippet:*/}
        {/*    <br />*/}
        {/*    <textarea*/}
        {/*      name={'codeSnippet'}*/}
        {/*      cols={0}*/}
        {/*      rows={0}*/}
        {/*      readOnly*/}
        {/*      value={codeSnippet}*/}
        {/*    />*/}
        {/*    <div className={styles.ButtonBlock}>*/}
        {/*      <Button*/}
        {/*        onClick={() => {*/}
        {/*          void navigator.clipboard.writeText(codeSnippet)*/}
        {/*          showToast('Copied to clipboard')*/}
        {/*        }}>*/}
        {/*        Copy to Clipboard*/}
        {/*      </Button>*/}
        {/*    </div>*/}
        {/*  </label>*/}
        {/*</div>*/}
      </div>
    </Box>
  )
}

export default EditWebsiteForm
